import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoggerService } from '@app/core/infrastructure';
import { AuthFacade } from '@app/store/auth/auth.facade';
import { Observable, of } from 'rxjs';
import { map, take, filter, switchMap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly logger = inject(LoggerService).scope('AuthGuard');

  constructor(
    private authFacade: AuthFacade,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authFacade.authStateResolved$.pipe(
      filter(Boolean),
      take(1),
      switchMap(() => this.authFacade.isAuthenticated$),
      take(1), // Take only the current authentication state
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        } else {
          // Redirect to login when not authenticated
          this.logger.debug('User not authenticated, redirecting to login');
          return this.router.createUrlTree(['/login']);
        }
      }),
      catchError((error) => {
        this.logger.error('Error during authentication check:', error);
        // Redirect to login on error
        return of(this.router.createUrlTree(['/login']));
      })
    );
  }
}